import React from 'react';
import { Page, Text, View, Image, Link, Font } from '@react-pdf/renderer';
import { LHalfCheck, LWarn, LSetting } from './svgDownloadIcons/svgDownloadIcons';
import generateImage from 'Utils/generateImage';
import ColorBox, { getInitialsListingSvg } from './downloadUtils/colorBox';
import config from 'config';
import { styles } from './style';
import { instareportFontFamily } from '../components/constant';

Font.register({ ...instareportFontFamily });

const WebsiteMobileDownload = ({ webData, details, user, score }) => {
    const regExp = /\(([^)]+)\)/;
    return (
        <Page wrap>
            <View fixed style={{ height: 20 }}>
                <Text />
            </View>
            <View style={styles.section}>
                <View style={styles.HeadingView}>
                    <View style={styles.HeadingLogo}>
                        {score?.website ? <ColorBox score={score?.website || 0} /> : null}
                        <Text style={styles.heading}>Website</Text>
                        <Text style={styles.HeadingCaption}>
                            Does your website turn clicks into customers?
                        </Text>
                    </View>
                </View>
                <View style={styles.RSubSection}>
                    <View>
                        <Text style={styles.RSubSectionText}>
                            79% of consumers research a business online before visiting in person or
                            making a purchase. Having a website that’s mobile responsive, optimized
                            for speed and beautifully crafted for conversions is the stepping stone
                            for every business.
                        </Text>
                        <Text style={styles.RSubSectionText}>
                            Using Google’s Page Speed Test, we ran an audit on{' '}
                            {details?.website || 'website'} to find any issues that can affect the
                            performance of your marketing efforts.
                        </Text>
                    </View>
                </View>
                <View>
                    <View style={styles.HeaderDivs}>
                        <View style={styles.HeadingLogo}>
                            {webData?.mobile?.grade ? (
                                <ColorBox score={webData?.mobile?.grade || 0} />
                            ) : null}
                            <Text>Mobile</Text>
                        </View>
                    </View>
                    <View style={styles.PSSummaryBox}>
                        <View style={styles.WBSSection} wrap={false}>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <Text style={styles.WBSSectionRowSubText}>
                                        Page Speed Summary
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LWarn color={'#f44336'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Should Fix</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.mobile?.shouldFix?.length}
                                </Text>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LSetting color={'#ffc13a'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Consider Fixing</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.mobile?.considerFixing?.length}
                                </Text>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LHalfCheck color={'#3facf7'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Passed</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.mobile?.passed?.length}
                                </Text>
                            </View>
                        </View>
                        <View style={styles.MobileViewBox}>
                            <Image
                                style={styles.MobileViewImageCover}
                                src={'/static/media/mobile.d3967dea.png'}
                            />
                            <Image
                                style={styles.MobileViewImage}
                                src={webData?.mobile?.screenshot}
                                alt={''}
                            />
                        </View>
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LWarn color={'#f44336'} />
                        </View>
                        <Text style={styles.FSStandard}>Should Fix</Text>
                    </View>
                    <View>
                        {webData?.mobile?.shouldFix?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}{' '}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LSetting color={'#ffc13a'} />
                        </View>
                        <Text style={styles.FSStandard}>Consider Fixing</Text>
                    </View>
                    <View>
                        {webData?.mobile?.considerFixing?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LHalfCheck color={'#3facf7'} />
                        </View>
                        <Text style={styles.FSStandard}>Passed</Text>
                    </View>
                    <View>
                        {webData?.mobile?.passed?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
            </View>
            <View style={styles.DesktopAlign}>
                <View style={styles.DesktopMainSection} wrap={false}>
                    <View style={styles.HeaderDivs}>
                        <View style={styles.HeadingLogo}>
                            {webData?.desktop?.grade ? (
                                <ColorBox score={webData?.desktop?.grade || 0} />
                            ) : null}
                            <Text>Desktop</Text>
                        </View>
                    </View>
                    <View style={styles.DesktopViewSection}>
                        <View style={styles.DesktopViewPSSummary}>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <Text style={styles.WBSSectionRowSubText}>
                                        Page Speed Summary
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LWarn color={'#f44336'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Should Fix</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.desktop?.shouldFix?.length}
                                </Text>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LSetting color={'#ffc13a'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Consider Fixing</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.desktop?.considerFixing?.length}
                                </Text>
                            </View>
                            <View style={styles.WBSSectionRow}>
                                <View style={styles.WBSSectionRowText}>
                                    <View style={styles.WBSSectionRowIcon}>
                                        <LHalfCheck color={'#3facf7'} />
                                    </View>
                                    <Text style={styles.WBSSectionRowSubText}>Passed</Text>
                                </View>
                                <Text style={styles.WBSSectionRowSubText}>
                                    {webData?.desktop?.passed?.length}
                                </Text>
                            </View>
                        </View>
                        <View style={styles.DesktopViewBox}>
                            <Image
                                style={styles.DesktopViewImageCover}
                                src={
                                    'data:image/png;base64,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'
                                }
                            />
                            <Image
                                style={styles.DesktopViewImage}
                                src={webData?.desktop?.screenshot}
                                alt={''}
                            />
                        </View>
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox1}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LWarn color={'#f44336'} />
                        </View>
                        <Text style={styles.FSStandard}>Should Fix</Text>
                    </View>
                    <View>
                        {webData?.desktop?.shouldFix?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox1}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LSetting color={'#ffc13a'} />
                        </View>
                        <Text style={styles.FSStandard}>Consider Fixing</Text>
                    </View>
                    <View>
                        {webData?.desktop?.considerFixing?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
                <View style={styles.MobileViewAnalysisBox1}>
                    <View style={styles.WBRSectionHeader}>
                        <View style={styles.MP2}>
                            <LHalfCheck color={'#3facf7'} />
                        </View>
                        <Text style={styles.FSStandard}>Passed</Text>
                    </View>
                    <View>
                        {webData?.desktop?.passed?.data?.slice(0)?.map((item, index) => (
                            <View key={index} style={styles.AnalysisInfoCard} wrap={false}>
                                <View style={styles.AnalysisInfoCardBox}>
                                    <Text style={styles.AnalysisInfoCardTitle}>{item?.title}</Text>
                                    <Text>{item?.displayValue}</Text>
                                </View>
                                <View>
                                    {item?.description ? (
                                        <Text>
                                            {item?.description.includes('[Learn')
                                                ? item?.description?.split('[Learn')[0]
                                                : ''}
                                            <Link
                                                src={
                                                    regExp?.test(item?.description || '()')
                                                        ? (regExp?.exec(
                                                              item?.description || '()',
                                                          ))[1]
                                                        : '#'
                                                }
                                                style={{ textDecoration: 'none' }}
                                            >
                                                Learn more
                                            </Link>
                                        </Text>
                                    ) : (
                                        <Text />
                                    )}
                                </View>
                            </View>
                        ))}
                    </View>
                </View>
            </View>
            <View style={styles.GITSection} wrap={false}>
                {!(typeof user?.image === 'string') ? (
                    <>
                        {Object.keys(user?.image || {})?.length > 0 ? (
                            <Image
                                src={generateImage(user?.image, user?.name)}
                                style={styles.GITUserImage}
                                alt={'image'}
                            />
                        ) : (
                            <View style={styles.GITSvgImage}>
                                {getInitialsListingSvg(user?.name)}
                            </View>
                        )}
                    </>
                ) : (
                    <Image
                        src={{
                            uri: `${config.REACT_APP_API_BASE_URL}/v1/corsproxy/`,
                            method: 'GET',
                            body: '',
                            headers: { 'Target-URL': `${user?.image}` },
                        }}
                        cache={false}
                        style={styles.GITUserImage}
                        alt={'image'}
                    />
                )}
                <Text style={styles.GITContent}>
                    Would you like to create a brand new website that converts your clicks into
                    customers? We can help!
                </Text>
            </View>
            <View fixed style={styles.FixedBottomHeight}>
                <Text />
            </View>
        </Page>
    );
};

export default WebsiteMobileDownload;
